module.exports = __webpack_public_path__ + "img/25x25_turuncu.0dc010c2.gif";